import { useState, useEffect } from 'react';

import { useRouter, useSearchParams } from 'src/routes/hooks';

import { CONFIG } from 'src/config-global';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export function GuestGuard({ children }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const { loading, authenticated, user } = useAuthContext();

  const [isChecking, setIsChecking] = useState(true);

  const returnTo = searchParams.get('returnTo') || CONFIG.auth.redirectPath;

  const checkPermissions = async () => {
    if (loading) {
      return;
    }

    // if (authenticated) {
    //   router.replace(returnTo);
    //   return;
    // }

    // if (authenticated && user) {
    //   const { ActivePage } = user;

    //   const allowedPages = [
    //     'Jobs',
    //     'Staff',
    //     'Clients',
    //     'Library',
    //   ];

    //   const validPage = allowedPages.includes(ActivePage);

    //   if (validPage) {
    //     router.replace(`/${ActivePage.toLowerCase()}`);
    //   } else {
    //     router.replace(`/jobs`);
    //   }
    // }

    setIsChecking(false);
  };

  useEffect(() => {
    checkPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, loading]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
